/**
 * Mask a string leaving only the last `visibleCount` characters.
 * Example: "someValue" -> "******lue"
 *
 * @param {string} str - The string to mask
 * @param {number} visibleCount - How many chars to leave visible at the end
 * @param {string} maskChar - Character to use for masking (default '*')
 * @returns {string} masked string
 */
export function maskString(str: string, visibleCount = 6, maskChar = "*") {
  if (typeof str !== "string") return str;
  if (str.length <= visibleCount) return str; // too short to mask
  const maskLength = str.length - visibleCount;
  return maskChar.repeat(maskLength) + str.slice(-visibleCount);
}
